import React from "react";
import { cn } from "../lib/utils";

// The caramel panel on the onboarding pages: the sign-in panel's warm colour
// (Login.tsx, while "Continue with Google" is hovered), the Caramel mark,
// then `children`.

type MeltPanelProps = {
  children?: React.ReactNode;
  className?: string;
};

export default function MeltPanel({ children, className }: MeltPanelProps) {
  return (
    <aside
      className={cn(
        "relative isolate m-4 flex flex-col overflow-hidden rounded-[22px] bg-[#EFD1A6] px-12 py-11 text-melt-text1",
        className
      )}
    >
      <div className="flex items-center gap-2.5 text-[18px] font-semibold">
        <img src="/logo-medium.svg" alt="" className="h-7 w-7" />
        Caramel
      </div>

      {children}
    </aside>
  );
}
